<template>
  <div>
    <v-flex style="max-width: 676px !important">
      <module-title class="title" title="Import/Export" />
      <v-flex>
        <v-layout :column="$vuetify.breakpoint.xs" class="cards-container">
          <v-flex
            class="import-export-card"
            @click="
              goTo(
                isSportOrganization() ? routes.sportOrganizer.importSport : routes.organizer.import,
              )
            "
          >
            <v-layout column align-center>
              <div class="import-export-image-margins"><img src="/assets/import.svg" /></div>
              <div class="import-export-name">Import</div>
              <div class="import-export-description import-export-screen-description-margins">
                Quickly import attendees and all of their data using a CSV template.
              </div>
            </v-layout>
          </v-flex>
          <v-flex
            class="import-export-card"
            @click="
              goTo(
                isSportOrganization() ? routes.sportOrganizer.exportSport : routes.organizer.export,
              )
            "
          >
            <v-layout column align-center>
              <img src="/assets/export.svg" class="import-export-image-margins" />
              <div class="import-export-name">Export</div>
              <div class="import-export-description import-export-screen-description-margins">
                Export a list of your attendees or a full set of your event's analytics data.
              </div>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
  </div>
</template>

<script>
import ModuleTitle from './../shared/module-title.vue'

export default {
  name: 'import-export-container',
  components: {
    ModuleTitle,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
  },
  methods: {
    isSportOrganization() {
      return this.$route.path.includes('/sport-organizations/')
    },
  },
}
</script>

<style>
.import-export-image-margins {
  margin-top: 32px;
}
.import-export-card {
  border-radius: 8px;
  background-color: #f5f5f5;
  cursor: pointer;
  max-width: 323px !important;
  margin-bottom: 30px;
}
@media (min-width: 600px) {
  .import-export-card:first-child {
    margin-right: 30px;
  }
  .import-export-card {
    margin-bottom: 0;
  }
}
@media (max-width: 800px) {
  .import-export-card {
    align-self: center;
  }
}
.import-export-card:hover {
  background-color: rgba(2, 119, 189, 0.2) !important;
}

.import-export-name {
  margin-bottom: 12px;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  margin-top: 0.75rem;
}
.import-export-description {
  font-size: 14px;
  color: #979797;
  font-family: Source Sans Pro, sans-serif;
}
.import-export-description.import-export-screen-description-margins {
  text-align: center;
}
.import-export-screen-description-margins {
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 32px;
}
.title-page {
  padding-top: 1.5rem;
  margin-bottom: 1.5rem;
}
@media screen and (max-width: 800px) {
  .title-page {
    display: none;
  }
  .cards-container {
    margin-top: 1.5rem;
  }
}
</style>
